var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 12.4499,
    r: 6.05,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.3999C16.8302 1.3999 21.5 5.80233 21.5 11.1538C21.4999 13.3391 20.8386 15.7614 19.8203 18.187C18.804 20.608 17.4444 23.0024 16.0791 25.1235C14.7146 27.2434 13.3497 29.0824 12.3252 30.3911C11.8131 31.0452 11.3867 31.5664 11.0889 31.9233C11.0581 31.9602 11.0279 31.9945 11 32.0278C10.9721 31.9945 10.9419 31.9602 10.9111 31.9233C10.6133 31.5664 10.1869 31.0452 9.6748 30.3911C8.65027 29.0824 7.28542 27.2434 5.9209 25.1235C4.55556 23.0024 3.19601 20.608 2.17969 18.187C1.16145 15.7614 0.500067 13.3391 0.5 11.1538C0.5 5.80233 5.1698 1.3999 11 1.3999ZM12.8809 7.62256C11.9835 7.23764 10.9949 7.13705 10.041 7.3335C9.08717 7.53 8.21335 8.0147 7.5293 8.72314C6.84547 9.43139 6.38116 10.3315 6.19336 11.3091C6.00562 12.2866 6.10206 13.3003 6.4707 14.2222C6.83938 15.144 7.46478 15.9349 8.27051 16.4927C9.07669 17.0506 10.0269 17.3501 11 17.3501H11.001C12.3056 17.3485 13.5528 16.8106 14.4697 15.8608C15.3861 14.9117 15.8989 13.6284 15.9004 12.2935V12.2925C15.9003 11.2962 15.6152 10.3208 15.0791 9.48975C14.5428 8.65845 13.7782 8.00751 12.8809 7.62256Z",
    fill: "#59B876",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71875 9.71924L13.1812 15.1816",
    stroke: "#59B876",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1812 9.71924L7.71875 15.1816",
    stroke: "#59B876",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon2);
export default __webpack_public_path__ + "static/media/OutletIcon2.cf34a1490f56312c65f95acc95e9e75f.svg";
export { ForwardRef as ReactComponent };